import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from './lib/auth';
import './index.css';
import 'leaflet/dist/leaflet.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <App />
        <Toaster
          position="top-center"
          toastOptions={{
            className: 'font-sans text-sm',
            style: {
              background: '#2D2926',
              color: '#F7F2EE',
              borderRadius: '9999px',
              padding: '12px 18px',
              boxShadow: '0 12px 40px -16px rgba(45,41,38,0.35)',
            },
            success: { iconTheme: { primary: '#B07A8A', secondary: '#F7F2EE' } },
            error: { iconTheme: { primary: '#F87171', secondary: '#F7F2EE' } },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
